import SolarCustomers from "./SolarCustomer.js";

export default SolarCustomers;
